import * as React from "react";
import { FaSpinner } from "react-icons/fa";
function Loader(_a) {
    var className = _a.className;
    return (React.createElement("div", { className: className
            ? "".concat(className, " mx-auto flex items-center justify-center text-black-300")
            : "mx-auto flex items-center justify-center text-black-300" },
        React.createElement(FaSpinner, { className: "animate-spin" })));
}
export var QueryLoader = function (_a) {
    var children = _a.children, isFetching = _a.isFetching, isLoading = _a.isLoading, isSuccess = _a.isSuccess, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    if (isLoading || isFetching)
        return React.createElement(Loader, { className: className });
    if (isSuccess || disabled)
        return React.createElement(React.Fragment, null, children);
    return null;
};
